<div class="builder-canvas">
	<!-- Header -->
	<div class="canvas-header">
		<h3 class="canvas-title">
			<mat-icon>edit_note</mat-icon>
			<span>Form Builder</span>
		</h3>
		<div class="canvas-info">
			<span class="field-count">{{ fields?.length || 0 }} fields</span>
		</div>
	</div>

	<!-- Drop Zone -->
	<div
		class="canvas-drop-zone"
		cdkDropList
		id="canvas-drop-zone"
		[cdkDropListData]="fields"
		(cdkDropListDropped)="onDrop($event)"
	>
		<!-- Empty State -->
		<div class="empty-state" *ngIf="!hasFields">
			<mat-icon>drag_indicator</mat-icon>
			<h4>No fields yet</h4>
			<p>Drag and drop fields from the left panel to start building your form</p>
		</div>

		<!-- Field List -->
		<div class="field-list" *ngIf="hasFields">
			<div *ngFor="let field of fields; let i = index" cdkDrag [cdkDragData]="field" class="field-wrapper">
				<div class="drag-preview" *cdkDragPreview>
					<mat-icon>drag_indicator</mat-icon>
					<span>{{ field?.props?.label || field?.key || 'Field' }}</span>
				</div>

				<nx-ahs-field-card
					[field]="field"
					[path]="[i]"
					[allFields]="fields"
					[isSelected]="isFieldSelected([i])"
					(fieldSelected)="onFieldSelected(field, [i])"
					(fieldUpdated)="onFieldUpdated(i, $event)"
					(deleteField)="onDeleteField(i)"
					(duplicateField)="onDuplicateField(i)"
					(moveUp)="onMoveUp(i)"
					(moveDown)="onMoveDown(i)"
				>
				</nx-ahs-field-card>
			</div>
		</div>
	</div>
</div>
